import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import MainLayout from 'components/layout/MainLayout';
import { useIsMobile } from 'hooks/ui/useIsMobile';
import React, { ReactNode } from 'react';
import EnterFlowFooter from '../EnterFlowFooter';
import { MainEnterFlowNavigation } from '../Navigation';
import styles from './V1EnterLayout.module.css';

interface V1EnterLayoutProps {
  mobileView: ReactNode;
  desktopLeft: ReactNode;
  desktopRight: ReactNode;
}

export const V1EnterLayout: React.FC<V1EnterLayoutProps> = (props) => {
  const { isMobile } = useIsMobile();
  return (
    <MainLayout
      limitItemWidths
      hideHeader
      additionalClassName="daymadeTypographyReset"
    >
      <MainEnterFlowNavigation fullWidthNav />
      {isMobile ? (
        <AboutUsModule background="grey">
          <AboutUsSiteContainer styles2026>
            {props.mobileView}
            <EnterFlowFooter />
          </AboutUsSiteContainer>
        </AboutUsModule>
      ) : (
        <AboutUsModule background="grey">
          <AboutUsSiteContainer styles2026>
            <div className={styles.desktopContainer}>
              <div className={styles.desktopLeft}>{props.desktopLeft}</div>
              <div className={styles.desktopRight}>{props.desktopRight}</div>
            </div>
            <EnterFlowFooter />
          </AboutUsSiteContainer>
        </AboutUsModule>
      )}
    </MainLayout>
  );
};

export default V1EnterLayout;
